"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class UserProfile extends complexData_1.default {
    constructor() {
        super(...arguments);
        //
        // User.getUserProfiles() uses this to store them. That must be some legacy stuff
        // coming from the similar function in the old extjs code. Just been added here
        // to avoid TS error as I wasn't brave enought to remove it completely.
        //
        this.roles = [];
    }
    static get allowedAssociations() {
        return {
            userProfileRoles: {
                key: 'userprofile_role',
                instance: (0, modelLookup_1.complexFindModel)('UserProfileRole'),
                condition: {
                    userprofile_id: this.Entity.getFieldSymbols().id,
                },
            },
        };
    }
}
UserProfile.Entity = entity_1.default;
UserProfile.modelProperties = modelProperties_1.default;
exports.default = UserProfile;
//# sourceMappingURL=../../../../src/models/userProfile/index.js.map